.wrapper[data-disabled] {
  background-color: transparent;
}

.label {
  font-weight: 600;
  font-size: var(--mantine-font-size-xs);
  color: var(--mantine-color-gray-8);
  margin-bottom: var(--mantine-spacing-xs);
}

.input {
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid var(--mantine-color-white);
  background-color: var(--mantine-color-white);

  box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);

  font-weight: 500;
  font-size: var(--mantine-font-size-sm);

  &:disabled {
    background-color: var(--mantine-color-gray-1);
    color: var(--mantine-color-gray-6);

    border: 1px solid var(--mantine-color-gray-1);
  }
}
